import { render, staticRenderFns } from "./article_in_partners_block.vue?vue&type=template&id=58dec669&lang=pug"
import script from "./article_in_partners_block.vue?vue&type=script&lang=js"
export * from "./article_in_partners_block.vue?vue&type=script&lang=js"
import style0 from "./article_in_partners_block.vue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports